export const getCopyright = (data: any) => ({
    holder: data.copyrightHolder,
    year: data.copyrightYear,
});

export const getKeyword = (data: any) => ({
    name: data.label,
});

export const getPublishingRightDate = (data: any) => ({
    start: data.availabilityStart,
    end: data.availabilityEnd,
});

export const getPublishingRight = (data: any) => ({
    id: data.id,
    countryCode: data.countryCode,
    type: data.rightsType,
    date: getPublishingRightDate(data),
});

export const getRole = (data: any) => ({
    id: data.id,
    roleType: data.roleType,
    name: data.label,
});

export const getVideoTechData = (data: any) => ({
    codec: data?.codec,
    wrapper: data?.wrapper,
    fileSizeBytes: data?.fileSizeBytes,
    totalRunTimeMilliseconds: data?.totalRunTimeMilliseconds,
    resX: data?.resX,
    resY: data?.resY,
    colorType: data?.colorType,
    partnerExternalVideoId: data?.partnerExternalVideoId,
    language: data?.language,
    framerateLabel: data?.framerateLabel,
    framerateNumerator: data?.framerateNumerator,
    framerateDenominator: data?.framerateDenominator,
});

export const getVideoSrc = (data: any) => ({
    main: data?.videoUrl,
    proxy: data?.proxyUrl,
});

export const getSourceVideo = (data: any) => ({
    techData: getVideoTechData(data),
    src: getVideoSrc(data),
});

export const getImageTechData = (data: any) => ({
    fileSizeBytes: data.fileSizeBytes,
    resX: data.resX,
    resY: data.resY,
    imageFormat: data.imageFormat,
});

export const getImage = (data: any) => ({
    id: data.id,
    imageType: data.artworkType,
    imageSrc: data.artworkUrl,
    techData: getImageTechData(data),
});

export const getComplianceRequirements = (data: any) => ({
    countryCode: data?.countryCode,
    captionRequired: data?.captionRequired,
});

export const getClosedCaption = (data: any) => ({
    timedTextFormat: data?.timedTextFormat,
    URLPointing: data?.timedTextUrl,
});

export default (data: any) => {
    const languageMeta = data.languageMeta?.[0];
    const filmTitle = languageMeta?.title;
    const filmDisplayTitle = languageMeta?.displayTitle;
    const filmSummary = languageMeta?.summary;
    const partner = data.contentPartner?.partnerName;
    const copyright = getCopyright(data);
    const plutoAvailsID = data.plutotvAvailsId;
    const {releaseDate} = data;
    const rating = data.territorialMeta[0]?.rating;
    const breakpointFrames = data.videoFile?.breakpointFrames;
    const genre = data.contentItemGenres?.[0]?.label;
    const category = languageMeta?.categories?.[0]?.label;
    const keywords = languageMeta?.keywords?.map(getKeyword);
    const publishingRights = data.publishingRights?.map(getPublishingRight);
    const complianceRequirements = getComplianceRequirements(data.complianceRequirements?.[0]);
    const roles = data.roleMeta?.map(getRole);
    const sourceVideo = getSourceVideo(data.videoFile);
    const images = data.artworks?.map(getImage);
    const closedCaption = getClosedCaption(data.videoFile?.timedTexts?.[0]);
    
    return {
        metaData: {
            filmTitle,
            filmDisplayTitle,
            filmSummary,
            partner,
            copyright,
            plutoAvailsID,
            releaseDate,
            rating,
            breakpointFrames,
            genre,
            category,
            keywords,
            publishingRights,
            complianceRequirements,
            roles,
        },
        assets: {
            sourceVideo,
            images,
            closedCaption,
        },
    };
};
